export default "__VITE_ASSET__Bu2jrte4__"